module.exports = __webpack_public_path__ + "static/media/Global Gaming Survey Report.b33344de.PNG";